"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.array.map.js");

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/createSuper"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _defaultsDeep2 = _interopRequireDefault(require("lodash/defaultsDeep"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactSlick = _interopRequireDefault(require("react-slick"));

var _classnames = _interopRequireDefault(require("classnames"));

var _tracking = require("@nerdwallet/nw-client-lib/tracking");

var _impression = require("@nerdwallet/analytics/react/impression");

var _arrows = require("./arrows");

var _utils = _interopRequireDefault(require("./utils"));

require("./carousel.less");

/* eslint-disable react/require-default-props */
var Carousel = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Carousel, _Component);

  var _super = (0, _createSuper2.default)(Carousel);

  function Carousel() {
    var _this;

    (0, _classCallCheck2.default)(this, Carousel);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "DEFAULT_SETTINGS", {
      appendDots: _this.appendDots.bind((0, _assertThisInitialized2.default)(_this)),
      arrows: true,
      infinite: false,
      nextArrow: /*#__PURE__*/_react.default.createElement(_arrows.ArrowNext, (0, _extends2.default)({}, _this.props, {
        impression: _this.context
      })),
      onSwipe: _this.onSwipe.bind((0, _assertThisInitialized2.default)(_this)),
      prevArrow: /*#__PURE__*/_react.default.createElement(_arrows.ArrowPrev, (0, _extends2.default)({}, _this.props, {
        impression: _this.context
      })),
      swipeToSlide: true
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleTouchStart", function (e) {
      var touch = e.touches[0] || e.changedTouches[0];
      _this.firstClientX = touch === null || touch === void 0 ? void 0 : touch.clientX;
      _this.firstClientY = touch === null || touch === void 0 ? void 0 : touch.clientY;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleTouchMove", function (e) {
      // Threshold value that scroll behavior has to exceed to prevent vertical scroll
      var minValue = 5;
      var touch = e.touches[0] || e.changedTouches[0];
      _this.clientX = (touch === null || touch === void 0 ? void 0 : touch.clientX) - _this.firstClientX;
      _this.clientY = (touch === null || touch === void 0 ? void 0 : touch.clientY) - _this.firstClientY; // Prevent vertical scrolling when horizontally scrolling in carousel.

      if (Math.abs(_this.clientX) > minValue) {
        e.preventDefault();
        e.stopPropagation();
      }

      return true;
    });
    return _this;
  }

  (0, _createClass2.default)(Carousel, [{
    key: "onSwipe",
    value: function onSwipe(direction) {
      var id = this.props.id;
      var entityName = this.props.entityName;
      var impression = this.context;
      (0, _utils.default)(id, impression, 'swipe', entityName);
      (0, _tracking.elementInteraction)({
        elementName: "carousel__body--".concat(id),
        interactionType: 'SWIPE',
        sectionCategory: 'carousel',
        elementCategory: 'body',
        elementDomType: 'div',
        elementContent: direction
      }); // Had to reach into the <InnerSlider> component to update
      // this internal variable to true, this is  known bug with react slick
      // see: https://github.com/akiran/react-slick/issues/604#issuecomment-400350967

      if (this.slider) {
        this.slider.innerSlider.clickable = true;
      }
    }
  }, {
    key: "appendDots",
    value: function appendDots(dots) {
      var _this2 = this;

      var _onClick = function onClick(e, options) {
        var id = _this2.props.id;
        var entityName = _this2.props.entityName;
        var impression = _this2.context;
        (0, _utils.default)(id, impression, 'press', entityName);
        (0, _tracking.elementInteraction)({
          elementName: "carousel__nav-dots--".concat(id),
          interactionType: 'CLICK',
          sectionCategory: 'carousel',
          elementCategory: 'nav-dots',
          elementDomType: 'button',
          elementPosition: options.elementPosition
        });

        if (options.onClick) {
          options.onClick(e);
        }
      };

      return /*#__PURE__*/_react.default.createElement("ul", null, _react.default.Children.map(dots, function (dot, index) {
        return /*#__PURE__*/_react.default.cloneElement(dot, {
          onClick: function onClick(event) {
            return _onClick(event, {
              elementPosition: index
            });
          }
        });
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          classname = _this$props.classname,
          children = _this$props.children;
      var settings = (0, _defaultsDeep2.default)({}, this.props, this.DEFAULT_SETTINGS);

      var sliderRef = function sliderRef(slider) {
        _this3.slider = slider;
      };

      return /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)(['carousel', settings.dots && 'has-dots', classname]),
        onTouchStart: this.handleTouchStart,
        onTouchMove: this.handleTouchMove
      }, /*#__PURE__*/_react.default.createElement(_reactSlick.default, (0, _extends2.default)({}, settings, {
        ref: sliderRef
      }), children));
    }
  }]);
  return Carousel;
}(_react.Component); // eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration


(0, _defineProperty2.default)(Carousel, "contextType", _impression.ImpressionContext);
Carousel.propTypes = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, _reactSlick.default.propTypes), {}, {
  /** ID used for tracking purposes. */
  id: _propTypes.default.string.isRequired,

  /** Classes applied to the carousel. */
  className: _propTypes.default.string,

  /** Slides to display in the carousel. */
  children: _propTypes.default.arrayOf(_propTypes.default.node),

  /** Entity name for tracking purposes */
  entityName: _propTypes.default.string
});
var _default = Carousel;
exports.default = _default;